import {defineAsyncComponent} from 'vue';
const opAccountEntryPrevYearDetail = defineAsyncComponent(() =>
  import('@/views/accountBalance/opAccountEntryPrevYear/OPAccountEntryPrevYearDetail.vue'),
);
const opAccountBalanceDetail = defineAsyncComponent(() =>
  import('@/views/accountBalance/opAccountBalance/OPAccountBalanceDetail.vue'),
);

const opDictionaryNotMatchPopup = defineAsyncComponent(() =>
  import('@/views/accountBalance/opAccountEntryPrevYear/OPDictionaryNotMatchPopup.vue'),
);

export function registerSetup(app) {
  app.component('OPAccountEntryPrevYearDetail', opAccountEntryPrevYearDetail);
  app.component('OPAccountBalanceDetail', opAccountBalanceDetail);
  app.component('OPDictionaryNotMatchPopup', opDictionaryNotMatchPopup);
}
